
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/remyndManual",
      function () {
        return require("private-next-pages/remyndManual/index.tsx");
      }
    ]);
  